import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
} from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LoginService } from '../../services/login-service/login.service';
import { DataShareService } from '../../services/data_share/data-share.service';
import { error } from 'console';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  loginDisplay = false;
  isIframe = false;
  userName: string = ''
  isAuthenticated: boolean = false;
  userID = '';
  isVisible: boolean = false;

  private loginStatusSubscription!: Subscription;

  constructor(
    private router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private loginService: LoginService,
    private dataSharing: DataShareService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.setLoginDisplay()
    }
  }

  ngOnInit(): void {
    // Subscribe to the isLoggedIn$ observable
    this.loginStatusSubscription = this.authService.isLoggedIn$.subscribe(
      (isLoggedIn) => {
        this.isVisible = isLoggedIn; // Update visibility dynamically
      }
    );
    if (isPlatformBrowser(this.platformId)) {
      this.isIframe = window !== window.parent && !window.opener;
      try {
        this.setLoginDisplay();

        this.msalService.instance.enableAccountStorageEvents();
        this.msalService.instance.addEventCallback((event) => {
          if (event.eventType === 'msal:loginSuccess' ||
            event.eventType === 'msal:logoutSuccess' ||
            event.eventType === 'msal:handleRedirectEnd') {
            this.setLoginDisplay();
          }
        });

        this.msalBroadcastService.inProgress$.pipe(filter((
          status: InteractionStatus) => status === InteractionStatus.None)
        ).subscribe(() => {
          this.setLoginDisplay()
        });
      }
      catch (error) {
        console.log("header error : ", error)
      }
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }

  Navigate_toView() {
    this.router.navigate(['/viewdatabase'])
  }

  setLoginDisplay(): void {
    this.isAuthenticated = this.msalService.instance.getAllAccounts().length > 0;
    this.loginDisplay = this.isAuthenticated

    if (this.isAuthenticated) {
      const activeAccount = this.msalService.instance.getActiveAccount();

      if (activeAccount) {
        this.userName = activeAccount.name || activeAccount.username || 'User';
      } else {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          this.userName = accounts[0].name || accounts[0].username || 'User';
        }
      }
    }
  }

  onLogout() {

    this.authService.logout();
    // const activeAccount = this.msalService.instance.getActiveAccount();
    // // this.dataSharing.presentUser$.subscribe(userdetails => {
    // //   this.userID = userdetails.session_id
    // // })
    // const sessionID = sessionStorage.getItem('Session_Id')

    // //const sessionID = activeAccount.homeAccountId;
    // this.loginService.appLogOut(sessionID).subscribe({
    //   next: () => {
    //     this.msalService.logoutRedirect({
    //       postLogoutRedirectUri: window.location.origin + '/loginpage',
    //     })
    //     this.msalService.logout();
    //   },
    //   error: (error) => {
    //     console.error("Logout API called and failed", error)
    //     this.msalService.logoutRedirect({
    //       postLogoutRedirectUri: window.location.origin + '/loginpage',
    //     })
    //   }
    // })
  }
}

